import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { useDeleteRequest } from '../../hooks/useDeleteRequest';
import { useGetRequest } from '../../hooks/useGetRequest';
import { usePatchRequest } from '../../hooks/usePatchRequest';
import { usePostRequest } from '../../hooks/usePostRequest';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from '../../utils/axiosRequests';
import { PHARMA_NAMES, sortMedicines } from '../../utils/helpers';

function PresetSettings() {
  const activeOrganization = useSelector(
    (state) => state.orgReducer.organization,
  );
  const navigate = useNavigate();
  const [presetSetting, setPresetSetting] = useState([]);
  const [name, setName] = useState('');
  const [filter, setFilter] = useState('');
  const [activeItem, setActiveItem] = useState('chief-complains');
  const [totalItem, setTotalItem] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 20;

  const [newItem, setNewItem] = useState({});
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [singleInnerItem, setSingleInnerItem] = useState(null);
  const [singleInnerItemForSave, setSingleInnerItemForSave] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pageTitle, setPageTitle] = useState('Chief Complain');
  const userInfo = useSelector((state) => state.authReducer.data);

  const [dynamicSections, setDynamicSections] = useState([]);
  const [activeDynamicSection, setActiveDynamicSection] = useState(null);

  const [isClearable, setIsClearable] = useState(true);
  const [isSearchable, setIsSearchable] = useState(true);
  const [medicineType, setMedicineType] = useState('Tablet');
  const [pharmaName, setPharmaName] = useState('');
  const [fromSearch, setFromSearch] = useState('');

  const handlePresetModalClose = () => setShowEditModal(false);
  const handleAddModalClose = () => setShowAddModal(false);
  const handleConfirmModalClose = () => setShowConfirmModal(false);

  // const medicineTypes = MEDICINE_TYPES.map((type) => ({
  //   value: type,
  //   label: type,
  // }));

  const medTypes = useSelector((state) => state.medicineTypeReducer.medTypes);

  const medicineTypes = medTypes?.map((medType) => ({
    value: medType.name,
    label: medType.name,
  }));

  const pharmaNames = PHARMA_NAMES.map((name) => ({
    value: name,
    label: name,
  }));

  const { isLoading: isPresetSettingsLoading, refetch: getPresetSetting } =
    useGetRequest(
      'presetSetting',
      `${activeItem}?organizationId=${activeOrganization.id}&page=${currentPage}&name=${name}&search=${fromSearch}`,
      (data) => {
        if (currentPage > 1) {
          //if data comes for search function then filter
          let sortedData = [];
          if (fromSearch) {
            sortedData = sortMedicines({
              medicines: data.data,
            });
          } else {
            sortedData = data.data;
          }
          setPresetSetting([...presetSetting, ...sortedData]);
        } else {
          //if data comes for search function then filter
          let sortedData = [];
          if (fromSearch) {
            sortedData = sortMedicines({
              medicines: data.data,
            });
          } else {
            sortedData = data.data;
          }
          setPresetSetting(sortedData);
          setTotalItem(data.total);
        }
      },
      (e) => {
        console.log(e);
      },
    );

  const { isLoading: isSavePresetLoading, mutate: updatePresetItem } =
    usePatchRequest(
      `${activeItem}/${singleInnerItem ? singleInnerItem.id : ''}`,
      singleInnerItemForSave,
      (data) => {
        const itemIndex = presetSetting.indexOf(singleInnerItem);
        const newPreset = [...presetSetting];
        // newPreset[itemIndex] = singleInnerItemForSave;
        newPreset[itemIndex] = data;
        setPresetSetting([...newPreset]);
        setShowEditModal(false);
      },
      (e) => {
        console.log(e);
        setShowEditModal(true);
      },
    );

  const { isLoading: isSaveNewPresetLoading, mutate: addPresetItem } =
    usePostRequest(
      `${activeItem}`,
      newItem,
      (data) => {
        // setPresetSetting([...presetSetting, data]);
        setShowAddModal(false);
        setNewItem({});
        getPresetSetting();
      },
      (e) => {
        console.log(e);
        toast.error(e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setShowAddModal(true);
      },
    );

  const { isLoading: isPresetDeleteLoading, mutate: deletePreset } =
    useDeleteRequest(
      `${activeItem}/${
        singleInnerItem ? singleInnerItem.id || singleInnerItem._id : ''
      }`,
      (data) => {
        const itemIndex = presetSetting.indexOf(singleInnerItem);
        const newPreset = [...presetSetting];
        newPreset.splice(itemIndex, 1);
        setPresetSetting([...newPreset]);
        setShowConfirmModal(false);
      },
      (e) => {
        console.log(e);
      },
    );

  useEffect(() => {
    getRequest('dynamic-prescription-items')
      .then((data) => {
        setDynamicSections(Array.isArray(data) ? data : data?.data || []);
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    setName('');
    setCurrentPage(1);
    setPresetSetting([]);
    if (activeItem !== 'dynamic-prescription-items') {
      getPresetSetting();
    }
  }, [activeItem]);

  useEffect(() => {
    if (activeItem !== 'dynamic-prescription-items') getPresetSetting();
  }, [currentPage]);

  useEffect(() => {
    if (activeItem !== 'dynamic-prescription-items') getPresetSetting();
  }, [filter]);

  useEffect(() => {
    if (activeItem !== 'dynamic-prescription-items' || !activeDynamicSection)
      return;
    const url = `dynamic-prescription-items/elements?prescriptionItemId=${activeDynamicSection.id}&page=${currentPage}&perPage=${perPage}${filter ? '&name=' + encodeURIComponent(filter) : ''}`;
    getRequest(url)
      .then((data) => {
        const items = Array.isArray(data) ? data : data?.data || [];
        if (currentPage > 1) {
          setPresetSetting((prev) => [...prev, ...items]);
        } else {
          setPresetSetting(items);
          setTotalItem(data?.total || items.length);
        }
      })
      .catch(console.error);
  }, [activeDynamicSection, currentPage, filter]);

  const handleItemSelection = (value) => {
    if (value.startsWith('dynamic:')) {
      const sectionId = value.slice('dynamic:'.length);
      const section = dynamicSections.find(
        (s) => (s.id || s._id) === sectionId,
      );
      setActiveDynamicSection(section || null);
      setActiveItem('dynamic-prescription-items');
    } else {
      setActiveDynamicSection(null);
      setActiveItem(value);
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();
    if (activeItem === 'medicines') {
      setFromSearch('yes');
    }
    setCurrentPage(1);
    setFilter(name);
  };

  const handleClear = () => {
    setFilter('');
  };

  const handleEditClick = (innerObj) => {
    setSingleInnerItem(innerObj);
    setMedicineType(innerObj.type);
    setPharmaName(innerObj.companyName);
    setShowEditModal(true);
  };

  const editTemplate = (template) => {
    console.log(template, 'template');
    navigate('/prescription', {
      state: {
        templateData: { ...template },
        history: 'fromReset',
      },
    });
  };

  const handleAddClick = (innerObj) => {
    addPresetItem();
  };

  const handleDeleteClick = (innerObj) => {
    setSingleInnerItem(innerObj);
    setShowConfirmModal(true);
  };

  const handleChangeInnerItem = (type = 'name', value) => {
    const currentItem =
      singleInnerItemForSave?.id === singleInnerItem?.id
        ? singleInnerItemForSave
        : singleInnerItem;
    const newItem = { ...currentItem, [type]: value };
    setSingleInnerItemForSave(newItem);
    // setPresetSetting([...newPreset]);
  };

  const handleAdNewItem = (type = 'name', value) => {
    setNewItem({ ...newItem, [type]: value });
  };

  const getModalTitle = () => {
    if (activeItem === 'chief-complains') {
      return 'Chief Complain';
    } else if (activeItem === 'diagnoses') {
      return 'Diagnosis';
    } else if (activeItem === 'medicines') {
      return 'Medicines';
    } else if (activeItem === 'advice') {
      return 'Advice';
    } else if (activeItem === 'followups') {
      return 'Follow Up';
    } else if (activeItem === 'observations') {
      return 'Observations';
    } else if (activeItem === 'investigations') {
      return 'Investigations';
    } else if (activeItem === 'treatment-plans') {
      return 'Treatment Plans';
    } else if (activeItem === 'instructions') {
      return 'Remarks';
    } else if (activeItem === 'physical-therapies') {
      return 'Physical Therapy';
    } else if (activeItem === 'exercises') {
      return 'Exercises';
    } else if (activeItem === 'orthoses') {
      return 'Orthoses';
    } else if (activeItem === 'medical-histories') {
      return 'Medical Histories';
    } else if (activeItem === 'referred-to') {
      return 'Referred To';
    } else if (activeItem === 'eyeglass-remarks') {
      return 'Eyeglass remarks';
    } else if (activeItem === 'dynamic-prescription-items') {
      return activeDynamicSection?.name || 'Dynamic Items';
    }
  };

  const handleDynamicAdd = async () => {
    if (!activeDynamicSection) return;
    try {
      const data = await postRequest('dynamic-prescription-items/elements', {
        name: newItem.name,
        prescriptionItemId: activeDynamicSection.id,
      });
      setPresetSetting((prev) => [...prev, data]);
      setShowAddModal(false);
      setNewItem({});
    } catch (e) {
      console.error(e);
    }
  };

  const handleDynamicUpdate = async () => {
    if (!singleInnerItem) return;
    const currentItem =
      singleInnerItemForSave?.id === singleInnerItem?.id
        ? singleInnerItemForSave
        : singleInnerItem;
    const id = currentItem?.id || currentItem?._id;
    try {
      const data = await patchRequest(
        `dynamic-prescription-items/elements/${id}`,
        currentItem,
      );
      const idx = presetSetting.indexOf(singleInnerItem);
      const updated = [...presetSetting];
      updated[idx] = data;
      setPresetSetting(updated);
      setShowEditModal(false);
    } catch (e) {
      console.error(e);
    }
  };

  const handleDynamicDelete = async () => {
    if (!singleInnerItem) return;
    const id = singleInnerItem?.id || singleInnerItem?._id;
    try {
      await deleteRequest(`dynamic-prescription-items/elements/${id}`);
      const idx = presetSetting.indexOf(singleInnerItem);
      const updated = [...presetSetting];
      updated.splice(idx, 1);
      setPresetSetting(updated);
      setShowConfirmModal(false);
    } catch (e) {
      console.error(e);
    }
  };

  const getInnterItemName = (item) => {
    if (activeItem === 'medicines') {
      return (
        <>
          <span
            style={{
              display: 'block',
              fontWeight: 'bold',
              paddingBottom: '.5rem',
              fontSize: '.9rem',
              color: '#3e3838',
            }}
          >
            {item?.brandName}
          </span>
          <span
            style={{ fontSize: 'small', fontStyle: 'italic', color: '#396bdf' }}
          >
            {item?.companyName}
          </span>
        </>
      );
    } else {
      return (
        <span
          style={{
            display: 'block',
            // fontWeight: 'bold',
            color: '#3e3838',
            fontSize: '.9rem',
          }}
        >
          {item.name}
        </span>
      );
    }
  };

  const doctorId = userInfo.id;

  const itemListObject = {
    'chief-complains': 'Chief Complains',
    diagnoses: 'Diagnosis',
    medicines: 'Rx',
    advice: 'Advice',
    followups: 'Follow Up',
    observations: 'Observations',
    investigations: 'Investigations',
    'treatment-plans': 'Treatment Plans',
    'referred-to': 'Referred To',
    'medical-histories': 'Medical Histories',
    'physical-therapies': 'Physical Therapies',
    exercises: 'Exercises',
    orthoses: 'Orthoses',
    instructions: 'Remarks',
    'eyeglass-remarks': 'Eyeglass Remarks',
    'prescriptions/templates': 'Prescription Templates',
  };

  return (
    <div fluid>
      <Row>
        {/* <Col xs={4} sm={4} md={3} lg={2} className="presetItemContainer">
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'chief-complains' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('chief-complains')}
          >
            Chief Complains
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'diagnoses' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('diagnoses')}
          >
            Diagnosis
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'medicines' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('medicines')}
          >
            Rx
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'advice' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('advice')}
          >
            Advice
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'followups' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('followups')}
          >
            Follow Up
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'observations' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('observations')}
          >
            Observations
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'investigations' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('investigations')}
          >
            Investigations
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'treatment-plans' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('treatment-plans')}
          >
            Treatment Plans
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'referred-to' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('referredto')}
          >
            Referred To
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'medical-histories' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('medical-histories')}
          >
            Medical Histories
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'physical-therapies' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('physical-therapies')}
          >
            Physical Therapies
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'exercises' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('exercises')}
          >
            Exercises
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'orthoses' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('orthoses')}
          >
            Orthoses
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'instructions' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('instructions')}
          >
            Remarks
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'eyeglass-remarks' ? 'presetItemSelected' : ''
            }`}
            onClick={() => handleItemSelection('eyeglass-remarks')}
          >
            Eyeglass Remarks
          </li>
          <li
            className={`cursor-pointer presetItem ${
              activeItem === 'prescriptions/templates'
                ? 'presetItemSelected'
                : ''
            }`}
            onClick={() => handleItemSelection('prescriptions/templates')}
          >
            Prescription Templates
          </li>
        </Col> */}

        <Col xs={12} sm={12} md={12} lg={12} fluid>
          <div className="col-xl-12 col-lg-12">
            <select
              name="preset-items"
              className="form-control"
              onChange={(e) => handleItemSelection(e.target.value)}
            >
              {Object.keys(itemListObject).map((key) => (
                <option key={key} value={key}>
                  {itemListObject[key]}
                </option>
              ))}
              {dynamicSections.map((section) => (
                <option
                  key={section.id || section._id}
                  value={`dynamic:${section.id || section._id}`}
                >
                  {section.name}
                </option>
              ))}
            </select>

            <div className="mb-4 py-3">
              {/* <div className="py-3 d-flex flex-row align-items-center justify-content-between"> */}
              <div className="row">
                <Col xs={8} sm={8} md={8} lg={8}>
                  <h6 className="m-0 font-weight-bold black">
                    {getModalTitle()} <br />
                    <small>
                      Showed{' '}
                      {currentPage * perPage < totalItem
                        ? currentPage * perPage
                        : totalItem}{' '}
                      of {totalItem}
                    </small>
                  </h6>
                </Col>
                <Col xs={4} sm={4} md={4} lg={4} className="text-center"></Col>
              </div>
              {/* </div> */}
              <div className="card-body py-3" style={{ minHeight: '75vh' }}>
                <Form className="mb-2">
                  <Row>
                    <Col xs={8} sm={8} md={8}>
                      <Form.Control
                        type="text"
                        className="form-control-sm"
                        placeholder="Search here"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Col>
                    <Col xs={4} sm={4} md={4}>
                      <Button
                        variant="outline-success"
                        type="submit"
                        className="btn-sm"
                        onClick={handleFilter}
                      >
                        <i className="fa fa-filter"></i> Filter
                      </Button>
                      <Button
                        style={{ marginLeft: '10px' }}
                        variant="outline-danger"
                        type="button"
                        className="btn-sm"
                        onClick={(e) => {
                          setName('');
                          handleClear();
                        }}
                      >
                        <i className="fa fa-redo" title="Show More"></i> Clear
                      </Button>

                      {activeItem !== 'prescriptions/templates' && (
                        <Button
                          variant="default"
                          className="btn btn-success btn-sm"
                          style={{ marginLeft: '6rem' }}
                          onClick={() => setShowAddModal(true)}
                        >
                          <i className="fa fa-plus-circle"></i> Create New
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Form>

                <Table hover>
                  <thead>
                    {activeItem === 'medicines' ? (
                      <tr>
                        <th style={{ width: '35%' }}>Name</th>
                        <th style={{ width: '30%' }}>Strength</th>
                        <th style={{ width: '15%', textAlign: 'right' }}>
                          Type
                        </th>
                        <th style={{ width: '10%', textAlign: 'right' }}>
                          Priority
                        </th>
                        <th style={{ width: '10%', textAlign: 'right' }}>
                          Action
                        </th>
                      </tr>
                    ) : (
                      <tr>
                        <th style={{ width: '70%' }}>Name</th>
                        <th style={{ width: '10%', textAlign: 'right' }}>
                          Priority
                        </th>
                        <th style={{ width: '20%', textAlign: 'right' }}>
                          Action
                        </th>
                      </tr>
                    )}
                  </thead>
                  <tbody>
                    {presetSetting &&
                      presetSetting.map((item) => (
                        <tr key={item.id}>
                          <td>{getInnterItemName(item)}</td>
                          {activeItem === 'medicines' && (
                            <td style={{ color: '#3e3838' }}>
                              {item?.strength}
                            </td>
                          )}
                          {activeItem === 'medicines' && (
                            <td
                              style={{ textAlign: 'right', color: '#f17c00' }}
                            >
                              {item?.type}
                            </td>
                          )}
                          <td style={{ textAlign: 'right' }}>
                            {item.priority ? item.priority : 0}
                          </td>
                          <td style={{ textAlign: 'right' }}>
                            <>
                              <i
                                style={{
                                  cursor: 'pointer',
                                  color: '#247e92',
                                }}
                                className="fa fa-edit"
                                onClick={() =>
                                  activeItem === 'prescriptions/templates'
                                    ? editTemplate(item)
                                    : handleEditClick(item)
                                }
                              ></i>
                              {activeItem !== 'medicines' && (
                                <i
                                  style={{
                                    cursor: 'pointer',
                                    marginLeft: '10px',
                                  }}
                                  className="far fa-trash-alt v-error"
                                  onClick={() => handleDeleteClick(item)}
                                ></i>
                              )}

                              {activeItem === 'medicines' &&
                                item.createdBy === doctorId && (
                                  <i
                                    style={{
                                      cursor: 'pointer',
                                      marginLeft: '10px',
                                    }}
                                    className="far fa-trash-alt v-error"
                                    onClick={() => handleDeleteClick(item)}
                                  ></i>
                                )}
                            </>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
                <div>
                  {presetSetting.length !== totalItem && (
                    <Button
                      className="btn-sm"
                      onClick={() => setCurrentPage(currentPage + 1)}
                    >
                      Load More
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Modal size="lg" show={showEditModal} onHide={handlePresetModalClose}>
        <Modal.Header className="common-modal-header">
          <Col>
            <Modal.Title>{getModalTitle()} Edit</Modal.Title>
          </Col>
          <Col md={4}></Col>
          <Col md={1} style={{ textAlign: 'end' }}>
            <i
              className="far fa-times-circle cursor-pointer"
              aria-hidden="true"
              onClick={handlePresetModalClose}
            ></i>
          </Col>
        </Modal.Header>
        <Modal.Body>
          {activeItem === 'medicines' &&
            singleInnerItem &&
            singleInnerItem.createdBy === doctorId && (
              <>
                <div className="form-group">
                  <label htmlFor="mobile-number">Brand Name</label>
                  <input
                    className="form-control"
                    type="text"
                    defaultValue={
                      singleInnerItem ? singleInnerItem.brandName : ''
                    }
                    onChange={(e) =>
                      handleChangeInnerItem('brandName', e.target.value)
                    }
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="mobile-number">Strength</label>
                  <input
                    className="form-control"
                    type="text"
                    defaultValue={
                      singleInnerItem ? singleInnerItem.strength : ''
                    }
                    onChange={(e) =>
                      handleChangeInnerItem('strength', e.target.value)
                    }
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="mobile-number">Generic Name</label>
                  <input
                    className="form-control"
                    type="text"
                    defaultValue={
                      singleInnerItem ? singleInnerItem.genericName : ''
                    }
                    onChange={(e) =>
                      handleChangeInnerItem('genericName', e.target.value)
                    }
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="mobile-number">Type</label>
                  <Select
                    className="basic-single"
                    classNamePrefix="Select Type"
                    defaultValue={{ label: 'Tablet', value: 'Tablet' }}
                    value={medicineTypes.filter(
                      (option) => option.label === medicineType,
                    )}
                    // isDisabled={isDisabled}
                    // isLoading={isLoading}
                    isClearable={true}
                    // isRtl={isRtl}
                    isSearchable={isSearchable}
                    name="type"
                    options={medicineTypes}
                    onChange={(e) => {
                      if (e) {
                        setMedicineType(e.value);
                        handleChangeInnerItem('type', e.value);
                      } else {
                        setMedicineType('Tablet');
                        handleChangeInnerItem('type', 'Tablet');
                      }
                    }}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="mobile-number">Company</label>
                  <Select
                    className="basic-single"
                    classNamePrefix="Select Company"
                    // defaultValue={pharmaNames.filter(
                    //   (option) => option.label === pharmaName,
                    // )}
                    value={pharmaNames.filter(
                      (option) => option.label === pharmaName,
                    )}
                    // isDisabled={isDisabled}
                    // isLoading={isLoading}
                    isClearable={true}
                    // isRtl={isRtl}
                    isSearchable={isSearchable}
                    name="type"
                    options={pharmaNames}
                    onChange={(e) => {
                      if (e) {
                        handleChangeInnerItem('companyName', e.value);
                      }
                    }}
                  />
                  {/* <input
                    className="form-control"
                    type="text"
                    defaultValue={
                      singleInnerItem ? singleInnerItem.companyName : ''
                    }
                    onChange={(e) =>
                      handleChangeInnerItem('companyName', e.target.value)
                    }
                  /> */}
                </div>
              </>
            )}

          {activeItem !== 'medicines' && (
            <div className="form-group">
              <label htmlFor="mobile-number">Name</label>
              <input
                className="form-control"
                type="text"
                defaultValue={singleInnerItem ? singleInnerItem.name : ''}
                onChange={(e) => handleChangeInnerItem('name', e.target.value)}
              />
            </div>
          )}
          <div className="form-group">
            <label htmlFor="mobile-number">Priority</label>
            <input
              className="form-control"
              type="text"
              defaultValue={singleInnerItem ? singleInnerItem.priority : ''}
              onChange={(e) =>
                handleChangeInnerItem('priority', e.target.value)
              }
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handlePresetModalClose}>
            Cancel
          </Button>{' '}
          <Button
            variant="primary"
            onClick={
              activeItem === 'dynamic-prescription-items'
                ? handleDynamicUpdate
                : updatePresetItem
            }
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal size="lg" show={showAddModal} onHide={handleAddModalClose}>
        <Modal.Header className="common-modal-header">
          <Col>
            <Modal.Title>{getModalTitle()} Add</Modal.Title>
          </Col>
          <Col md={4}></Col>
          <Col md={1} style={{ textAlign: 'end' }}>
            <i
              className="far fa-times-circle cursor-pointer"
              aria-hidden="true"
              onClick={handleAddModalClose}
            ></i>
          </Col>
        </Modal.Header>
        <Modal.Body>
          {activeItem === 'medicines' && (
            <>
              <div className="form-group">
                <label htmlFor="mobile-number">Brand Name</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={''}
                  placeholder="Enter only brand name please"
                  onChange={(e) => handleAdNewItem('brandName', e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="mobile-number">Strength</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={''}
                  onChange={(e) => handleAdNewItem('strength', e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="mobile-number">Generic Name</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={''}
                  onChange={(e) =>
                    handleAdNewItem('genericName', e.target.value)
                  }
                />
              </div>
              <div className="form-group">
                <label htmlFor="mobile-number">Type</label>
                <Select
                  className="basic-single"
                  classNamePrefix="Select Type"
                  defaultValue={'Tablet'}
                  // isDisabled={isDisabled}
                  // isLoading={isLoading}
                  isClearable={true}
                  // isRtl={isRtl}
                  isSearchable={isSearchable}
                  name="type"
                  options={medicineTypes}
                  onChange={(e) => {
                    if (e) {
                      handleAdNewItem('type', e.value);
                    } else {
                      handleAdNewItem('type', 'Tablet');
                    }
                  }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="mobile-number">Company</label>
                <Select
                  className="basic-single"
                  classNamePrefix="Select Company"
                  // defaultValue={{ label: 'Tablet', value: 'Tablet' }}
                  value={pharmaNames.filter(
                    (option) => option.label === newItem?.companyName,
                  )}
                  // isDisabled={isDisabled}
                  // isLoading={isLoading}
                  isClearable={true}
                  // isRtl={isRtl}
                  isSearchable={isSearchable}
                  name="type"
                  options={pharmaNames}
                  onChange={(e) => {
                    if (e) {
                      handleAdNewItem('companyName', e.value);
                    }
                  }}
                />
              </div>
            </>
          )}

          {activeItem !== 'medicines' && (
            <div className="form-group">
              <label htmlFor="mobile-number">Name</label>
              <input
                className="form-control"
                type="text"
                defaultValue={''}
                onChange={(e) => handleAdNewItem('name', e.target.value)}
              />
            </div>
          )}

          <div className="form-group">
            <label htmlFor="mobile-number">Priority</label>
            <input
              className="form-control"
              type="text"
              defaultValue={'0'}
              onChange={(e) => handleAdNewItem('priority', e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleAddModalClose}>
            Cancel
          </Button>{' '}
          <Button
            variant="primary"
            onClick={
              activeItem === 'dynamic-prescription-items'
                ? handleDynamicAdd
                : handleAddClick
            }
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal size="lg" show={showConfirmModal} onHide={handleConfirmModalClose}>
        <Modal.Header className="common-modal-header">
          <Col>
            <Modal.Title>{getModalTitle()} Delete</Modal.Title>
          </Col>
          <Col md={4}></Col>
          <Col md={1} style={{ textAlign: 'end' }}>
            <i
              className="far fa-times-circle cursor-pointer"
              aria-hidden="true"
              onClick={handlePresetModalClose}
            ></i>
          </Col>
        </Modal.Header>
        <Modal.Body>Are you sure want to delete?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleConfirmModalClose}>
            Cancel
          </Button>{' '}
          <Button
            variant="primary"
            onClick={
              activeItem === 'dynamic-prescription-items'
                ? handleDynamicDelete
                : deletePreset
            }
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PresetSettings;
